import {UserComponentManager} from './UserComponentManager';
import * as pc from 'playcanvas';
import {MouseManager} from '../MouseManager';

const Component_DeformRipple = UserComponentManager.createComponent('deformRipple');

Component_DeformRipple.MasterSettings = {
  strength: 0.01,
  falloff: 1.30,
  freq: 1.3,
  rate: 0.8,
  mouseRippleDecay: 2,
  rippleMin: 0.01,
  rippleMax: 2,
  ripplePower: 3,
  ripplePower_normal: 3,
  ripplePower_breathe: 0.5,
  rippleAffectScale: 10,
  rippleAffectTime: 0.1,
  shakeParticleThreshold: 0.1,
  plantScene: undefined,
  inputXHistory: [0, 0, 0, 0],
};
Component_DeformRipple.init = function() { };
Component_DeformRipple.GetParams = function() {
  return {
    // attributes
    offset: 0,
    scale: 1,
    rate: 1,
    mass: 1,
    normX: 0.5,
    index: 0,

    // internal vars
    time: 0,
    vertPositions: [],
    meshes: [],
    userRippleStrength: 0,
  };
};
Component_DeformRipple.attachToEntity = function(entity) {
  const p = Component_DeformRipple.GetParams();
  p.entity = entity;
  this.e_glb = entity.children[0];
  for (let i = 0; i < this.e_glb.render.meshInstances.length; i++) {
    const mesh = this.e_glb.render.meshInstances[i].mesh;
    const vert_positions = [];
    const vert_lengths = [];
    mesh.getPositions(vert_positions);

    // falloff strength based on distance from origin
    for (let k = 0; k < vert_positions.length; k += 3) {
      this.vec = new pc.Vec3(vert_positions[k], vert_positions[k + 1], vert_positions[k + 2]);
      vert_lengths[k] = this.vec.length();
      delete this.vec;
    }
    // data object
    p.meshes[i] = {mesh: mesh, vert_positions: vert_positions, vert_lengths: vert_lengths};
  }
  delete this.e_glb;

  this.active[entity.name] = p;
  return p;
};
Component_DeformRipple.systemUpdate = function(dt) {
  const masterSettings = Component_DeformRipple.MasterSettings;
  const mm = MouseManager;

  masterSettings.inputXHistory.pop();
  masterSettings.inputXHistory.unshift({nx: mm.nx, ny: mm.ny, dx: mm.dx, dy: mm.dy});

  let inputXSum = 0;
  const inputYSum = 0;
  let minX = 99;
  let maxX = -99;

  masterSettings.inputXHistory.forEach((i) => {
    inputXSum += i.dx;
    inputXSum += i.dy;
    minX = Math.min(minX, i.nx);
    maxX = Math.max(maxX, i.nx);
  });
  const middleX = minX + ((maxX - minX) * 0.5);
  const push = Math.max(Math.abs(inputXSum), Math.abs(inputYSum));
  if (push > 0) {
    const power = push * masterSettings.ripplePower;
    for (const key in this.active) {
      if (Object.hasOwnProperty.call(this.active, key)) {
        const comp = this.active[key];
        const normX = comp.normX;
        const diff = middleX - normX;
        const closeness = Math.pow(1 - Math.abs(diff), 8);

        const appliedStrength = (power * closeness);
        if (appliedStrength > masterSettings.shakeParticleThreshold) {
          masterSettings.plantScene.disturbPlantStem(comp.index);
        }
        comp.userRippleStrength += appliedStrength;
      }
    }
  } else {
    if (masterSettings.plantScene) {
      masterSettings.plantScene.stopShakeParticles();
    }
  }
};

Component_DeformRipple.do = function(obj, dt) {
  const master = Component_DeformRipple.MasterSettings;
  obj.userRippleStrength = pc.math.clamp(obj.userRippleStrength, 0, master.rippleMax);
  obj.time += dt * (master.rate * obj.rate);
  obj.time += (obj.userRippleStrength * master.rippleAffectTime);
  obj.time %= Math.PI * 2;
  const t = obj.time + obj.offset;
  const strength = master.strength;
  const falloff = master.falloff;
  const freq = master.freq * obj.scale;


  // obj.temp_vert_positions.length = 0;
  const vp = obj.meshes[0].vert_positions;
  const vl = obj.meshes[0].vert_lengths;

  // loop over all positions, and fill up tempPositions array with waved version of positions from vert_positions array
  // modify .x and .z components based on sin function, which uses .y component
  let off_x = 0;
  let off_z = 0;
  for (let k = 0; k < vp.length; k += 3) {
    const master_strength = (vl[k] / falloff) * strength;

    off_x = vp[k] + Math.sin(t + vp[k + 1] * freq) * master_strength;
    off_z = vp[k + 2] + Math.sin(t + vp[k + 1] * freq) * master_strength;

    obj.vertPositions[k] = off_x;
    obj.vertPositions[k + 1] = vp[k + 1];
    obj.vertPositions[k + 2] = off_z;
  }
  // set new positions on the mesh
  const mesh = obj.meshes[0].mesh;
  mesh.setPositions(obj.vertPositions);
  mesh.update();

  obj.userRippleStrength = pc.math.clamp(obj.userRippleStrength -= (master.mouseRippleDecay * dt), 0);
};
Component_DeformRipple.getVertPos = function(obj, vertIndex) {
  const vx3 = vertIndex * 3;
  const vertPos = {x: obj.vertPositions[vx3] * 2, y: obj.vertPositions[vx3 + 1] * 2, z: obj.vertPositions[vx3 + 2] * 2};
  const partPos = obj.entity.getPosition();
  return {x: partPos.x + vertPos.x, y: partPos.y + vertPos.y, z: partPos.z + vertPos.z};
};
Component_DeformRipple.init();
export {Component_DeformRipple};

/*

*/
